import { DateTime } from "luxon"
import { ListingItemCardFragment } from "../__generated__/ListingItemCardFragment"

export const listingIsUnavailable = (listing: ListingItemCardFragment) =>
  listing.last_available_at === null ||
  DateTime.fromISO(listing.last_available_at).diffNow().days > 31
